var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"dragscroll",rawName:"v-dragscroll"}],staticStyle:{"overflow-x":"scroll","display":"grid","grid-auto-flow":"column","grid-auto-columns":"max-content"},style:({gridGap:_vm.gap})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }